import { render, staticRenderFns } from "./Brigade.vue?vue&type=template&id=4b5b2086&scoped=true"
import script from "./Brigade.vue?vue&type=script&lang=js"
export * from "./Brigade.vue?vue&type=script&lang=js"
import style0 from "./Brigade.vue?vue&type=style&index=0&id=4b5b2086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b2086",
  null
  
)

export default component.exports